<span class="mb-0">{{amount | centConversion | currency: currency}}</span>
